import React from 'react';

import { Box, Button, H1, Text, VStack } from '@betterment/samba-react';

import { useCustomFundLineup } from '../../../contexts/CustomFundLineupContext';
import { CustomFundLineupLayout } from '../CustomFundLineupLayout';

export const CsvValidatedStep: React.FC = () => {
  const { planName, returnTo } = useCustomFundLineup();

  const handleContinue = () => {
    window.location.assign(returnTo || '/');
  };

  return (
    <CustomFundLineupLayout>
      <Box css={{ flex: 1, display: 'flex', flexDirection: 'column', alignItems: 'center', py: 'space.600' }}>
        <VStack css={{ maxWidth: '584px', width: '100%', gap: 'space.400' }}>
          <H1 variant="title400">We are creating your fund lineup.</H1>
          <Text variant="text100">
            We've successfully validated your fund lineup for{' '}
            <Text as="span" css={{ fontWeight: 700 }}>
              {planName}
            </Text>{' '}
            and are processing it now. It should be fully created and applied to the plan a few minutes after your
            client signs their plan document.
          </Text>
          <Button variant="solidPrimary" onClick={handleContinue}>
            Continue
          </Button>
        </VStack>
      </Box>
    </CustomFundLineupLayout>
  );
};
